import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TreatmentWizardSettingsState } from '../../../../shared/state/treatment-wizard-settings/treatment-wizard-settings.store';
import { Platform } from '@ionic/angular';
import { ClinicDetailQuery } from 'src/app/shared/state/clinic-detail/clinic-detail.query';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
    selector: 'app-shipping-config',
    templateUrl: './shipping-config.component.html',
    styleUrls: ['./shipping-config.component.scss'],
})
export class ShippingConfigComponent implements OnInit {
    @Input() treatmentWizardSettings: TreatmentWizardSettingsState;

    @Output() cancelShippingChangeEvent = new EventEmitter<boolean>();
    @Output() confirmShippingChangeEvent = new EventEmitter<boolean>();
    @Output() updateShippingAddressEvent = new EventEmitter<string>();

    canEditShippingAddress = false;
    ios;

    /** Flowwwer template */
    clinicAdress$ :Observable<any>

    constructor(private platform: Platform, private clinicDetailQuery: ClinicDetailQuery) {
        this.ios = this.platform.is('ios');
    }

    ngOnInit(): void {
        this.clinicAdress$ = combineLatest([
            this.clinicDetailQuery.select('address1'),
            this.clinicDetailQuery.select('address2'),
            this.clinicDetailQuery.select('address3')
        ]).pipe(
            map((address: string[]) => {
                return address.join(' ')
            })
        )
    }
    
    toggleCancelShipping() {
        this.cancelShippingChangeEvent.emit(!this.treatmentWizardSettings.cancelShippingUserChecked)
    }
    
    toggleConfirmShipping() {
        this.confirmShippingChangeEvent.emit(!this.treatmentWizardSettings.confirmShippingUserChecked);
    }

    changeCancelShipping(event) {
        if (
            event.currentTarget.checked === true ||
            event.currentTarget.checked === false
        ) {
            this.cancelShippingChangeEvent.emit(event.currentTarget.checked);
        }
    }

    changeConfirmShipping(event) {
        if (
            event.currentTarget.checked === true ||
            event.currentTarget.checked === false
        ) {
            this.confirmShippingChangeEvent.emit(event.currentTarget.checked);
        }
    }

    updateShippingAddress(event) {
        this.updateShippingAddressEvent.emit(event.target.value);
    }
}
